import { render, staticRenderFns } from "./review-breadcrumbs.vue?vue&type=template&id=331eec0c"
import script from "./review-breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./review-breadcrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports